// Auto generated file, do not manually modify!
// com.hotpads.place.client.area.enums.DeprecatedZillowRegionType

export enum DeprecatedZillowRegionType {
  Airport = 'Airport',
  AirportNoiseContour = 'AirportNoiseContour',
  Boroughs = 'Boroughs',
  CBSADivision = 'CBSADivision',
  CensusTract = 'CensusTract',
  City = 'City',
  College = 'College',
  CombinedStatArea = 'CombinedStatArea',
  CompositeRegion = 'CompositeRegion',
  CongressionalDistrict = 'CongressionalDistrict',
  CoreBasedStatArea = 'CoreBasedStatArea',
  Country = 'Country',
  County = 'County',
  DesignatedMarketArea = 'DesignatedMarketArea',
  ElementarySchool = 'ElementarySchool',
  FlexRegion = 'FlexRegion',
  HighSchool = 'HighSchool',
  IndependentCity = 'IndependentCity',
  MasterCommunity = 'MasterCommunity',
  Megalopolis = 'Megalopolis',
  MiddleSchool = 'MiddleSchool',
  MilitaryBase = 'MilitaryBase',
  Neighborhood = 'Neighborhood',
  Road = 'Road',
  SalesRegion = 'SalesRegion',
  SchoolDistrict = 'SchoolDistrict',
  SchoolFragment = 'SchoolFragment',
  Search = 'Search',
  State = 'State',
  Subdivision = 'Subdivision',
  TimeZone = 'TimeZone',
  USTerritory = 'USTerritory',
  UserDefined = 'UserDefined',
  ZipCode = 'ZipCode',
}

export const DeprecatedZillowRegionType_values = [
  DeprecatedZillowRegionType.Airport,
  DeprecatedZillowRegionType.AirportNoiseContour,
  DeprecatedZillowRegionType.Boroughs,
  DeprecatedZillowRegionType.CBSADivision,
  DeprecatedZillowRegionType.CensusTract,
  DeprecatedZillowRegionType.City,
  DeprecatedZillowRegionType.College,
  DeprecatedZillowRegionType.CombinedStatArea,
  DeprecatedZillowRegionType.CompositeRegion,
  DeprecatedZillowRegionType.CongressionalDistrict,
  DeprecatedZillowRegionType.CoreBasedStatArea,
  DeprecatedZillowRegionType.Country,
  DeprecatedZillowRegionType.County,
  DeprecatedZillowRegionType.DesignatedMarketArea,
  DeprecatedZillowRegionType.ElementarySchool,
  DeprecatedZillowRegionType.FlexRegion,
  DeprecatedZillowRegionType.HighSchool,
  DeprecatedZillowRegionType.IndependentCity,
  DeprecatedZillowRegionType.MasterCommunity,
  DeprecatedZillowRegionType.Megalopolis,
  DeprecatedZillowRegionType.MiddleSchool,
  DeprecatedZillowRegionType.MilitaryBase,
  DeprecatedZillowRegionType.Neighborhood,
  DeprecatedZillowRegionType.Road,
  DeprecatedZillowRegionType.SalesRegion,
  DeprecatedZillowRegionType.SchoolDistrict,
  DeprecatedZillowRegionType.SchoolFragment,
  DeprecatedZillowRegionType.Search,
  DeprecatedZillowRegionType.State,
  DeprecatedZillowRegionType.Subdivision,
  DeprecatedZillowRegionType.TimeZone,
  DeprecatedZillowRegionType.USTerritory,
  DeprecatedZillowRegionType.UserDefined,
  DeprecatedZillowRegionType.ZipCode,
] as const;
